<template>
  <router-link :to="{ params: { selectedBullet: index }  }">
    <div class="bullet" :style="'left: ' + x + '%; ' + 'top: ' + y + '%'">
      <span class="bullet__label">{{index + 1}}</span>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'bullet',
  props: ['x', 'y', 'index'],
};
</script>

<style lang="scss">
  @import '../scss/helpers.scss';
  .bullet {
    display: block;
    position: absolute;
    height: 40px;
    width: 40px;
    background: rgba($c_primary, .9);
    transition: opacity .15s;
    opacity: 0;
    font-size: 18px;
    font-weight: bold;
    box-sizing: border-box;
    border-radius: 50%;
    color: $c_white;
    text-align: center;
    transform: translate(-20px, -20px);
    box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.31);

    &__label {
      display: inline-block;
      position: absolute;
      top: 20px;
      left: 20px;
      transform: translate(-50%, -50%);
      @include font-baseline-fix;

    }

    .show & {
      opacity: 1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Bullet.vue